// Message importance in 1:1 and group chats (channel posts have their own column). A flagged message travels as a wrapper
// around its HTML, <div data-fg-importance="important|urgent">…</div>, so no schema change is needed; the sanitiser keeps data-*.

export type Importance = "standard" | "important" | "urgent";

const ATTR = "data-fg-importance";
const WRAP = /^\s*<div data-fg-importance="(important|urgent)">([\s\S]*)<\/div>\s*$/;

export function wrapImportance(html: string, importance: Importance): string {
    return importance === "standard" ? html : `<div ${ATTR}="${importance}">${html}</div>`;
}

/** The importance a body carries and the body without its wrapper. */
export function splitImportance(html: string): { importance: Importance; html: string } {
    const m = WRAP.exec(html);
    return m ? { importance: m[1] as Importance, html: m[2]! } : { importance: "standard", html };
}
